import React from "react";
import * as Yup from "yup";
import {
  PTCheckbox,
  PTDateInput,
  PTFileInput,
  PTForm,
  PTRadioGroup,
  PTSelectInput,
  PTTextInput,
} from "../../../common/components/ui";
import PTTranslate from "../../../common/components/ui/PTTranslate";
import { translate } from "../../../common/utils/translate";
import { exemplePostValidationSchema } from "../others/exempleValidationSchemas";

function ExampleComponent() {
  const handleSubmit = (values) => {
  };

  const genderOptions = [
    { value: "male", label: "Male" },
    { value: "female", label: "Female" },
    { value: "other", label: "Other" },
  ];

  return (
    <div className="App">
      <h1>
        <PTTranslate tk={"welcome"} />
      </h1>
      <p>{translate("description")}</p>
      <PTForm
        name="userForm"
        initialValues={{
          email: "",
          password: "",
          gender: "",
          terms: false,
          birthDate: "",
          avatar: null,
        }}
        onSubmit={handleSubmit}
        validationSchema={exemplePostValidationSchema}
      >
        <PTTextInput xs={4} name="email" label="Email" type="email" />
        <PTTextInput xs={4} name="password" label="Password" type="password" />
        <PTSelectInput
          isHidden={() => false}
          xs={4}
          name="gender"
          label="Gender"
          valueRenderer={(option) => option.value}
          reference={"LISTE_PAYS"}
          data={genderOptions}
        />
        <PTSelectInput
          isHidden={() => true}
          xs={4}
          name="gender"
          label="Gender"
          options={genderOptions}
        />
        <PTDateInput xs={4} name="birthDate" label="Birth Date" />
        <PTRadioGroup
          xs={4}
          name="newsletter"
          label="Subscribe to newsletter?"
          options={[
            { value: "yes", label: "Yes" },
            { value: "no", label: "No" },
          ]}
        />
        <PTCheckbox
          xs={4}
          name="terms"
          label="I accept the terms and conditions"
        />
        <PTFileInput xs={4} name="avatar" label="Upload Avatar" />
      </PTForm>
    </div>
  );
}

export default ExampleComponent;
